import { SubAPI } from "./SubAPI";
export class ProjectJournal extends SubAPI {
    list(props) { return this.fetcher.get("/api/project-journal", props); }
}
